import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getUserTrainings } from 'api/Admin/Trainings/Trainings';

export const useGetUserTrainings = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['user-trainings', ...dependencies], () => getUserTrainings(navigate, params), {
    enabled: !!params.practiceId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5000,
    ...options
  });
};
